<style lang="scss" scoped>
.manage-presets-modal {
    padding: 0 6px;
}

.presets-header {
    margin-bottom: 10px;
}

.presets-title {
    font-size: 1.2em;
    font-weight: 600;
    color: #333;
    margin: 0 0 2px;
}

.presets-subtitle {
    font-size: 0.95em;
    color: #777;
    margin: 0;
}

.presets-empty {
    text-align: center;
    color: #aaa;
    padding: 16px 0;
    font-size: 1em;
}

.presets-error {
    background: #fff3f3;
    border: 1px solid #f5c6c6;
    color: #c0392b;
    border-radius: 5px;
    padding: 7px 12px;
    margin-bottom: 8px;
    font-size: 0.9em;
}

.preset-row {
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 8px;
    background: #fafafa;
}

.preset-grid {
    display: grid;
    gap: 8px;
    margin-bottom: 6px;
}

.preset-grid--row1 {
    grid-template-columns: 3fr 1fr;
}

.preset-grid--row2 {
    grid-template-columns: 1fr 1fr 1fr;
}

.preset-field label {
    display: block;
    font-size: 0.8em;
    font-weight: 600;
    color: #555;
    margin-bottom: 2px;
}

.preset-field input[type="number"],
.preset-field input[type="text"],
.preset-field textarea {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 0.9em;
    height: 32px;
    box-sizing: border-box;
    &:focus {
        outline: none;
        border-color: #ff8c00;
    }
}

.preset-field textarea {
    height: auto;
    resize: vertical;
}

.presets-footer {
    display: flex;
    justify-content: flex-end;
    gap: 6px;
    margin-top: 8px;
}

.preset-row-actions {
    grid-template-columns: 1fr auto;
    align-items: stretch;
    gap: 8px;
    margin-top: 6px;
    textarea {
        height: 100%;
        min-height: 52px;
    }
}

.preset-action-btns {
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: center;
}

.presets-add {
    margin-top: 6px;
}

::v-deep .multiselect--disabled {
    opacity: 1 !important;
    .multiselect__select {
        display: none;
    }
    .multiselect__tags {
        background: #f0f0f0 !important;
        border-color: #ddd !important;
        cursor: not-allowed;
    }
    .multiselect__single {
        background: transparent;
        color: #555;
        font-style: italic;
    }
}

::v-deep .c-btn-save {
    background: #31cd72 !important;
    color: white !important;
    border-color: #31cd72 !important;
    width: 34px !important;
    max-width: 34px !important;
    min-width: 34px !important;
    height: 34px !important;
    padding: 0 !important;
    border-radius: 6px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    i {
        color: white !important;
        font-size: 0.95rem;
    }
    &:hover:not(:disabled) {
        background: #27b362 !important;
        border-color: #27b362 !important;
    }
    &:disabled {
        opacity: 0.5;
    }
}

::v-deep .c-btn-remove {
    background: #e74c3c !important;
    color: white !important;
    border-color: #e74c3c !important;
    width: 34px !important;
    max-width: 34px !important;
    min-width: 34px !important;
    height: 34px !important;
    padding: 0 !important;
    border-radius: 6px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    i {
        color: white !important;
        font-size: 0.95rem;
    }
    &:hover:not(:disabled) {
        background: #c0392b !important;
        border-color: #c0392b !important;
    }
    &:disabled {
        opacity: 0.5;
    }
}
</style>

<template>
    <cc-modal :modal="modal" @close="close">
        <div slot="body" class="manage-presets-modal">
            <div class="presets-header">
                <p class="presets-title">{{ displayLabel }}</p>
                <p class="presets-subtitle">Gerencie os presets de conciliação para este produto.</p>
            </div>

            <div v-if="error" class="presets-error">{{ error }}</div>

            <cc-loader v-if="loading" />

            <div v-if="!loading && presets.length === 0" class="presets-empty">
                Nenhum preset cadastrado.
            </div>

            <div v-if="!loading" v-for="(preset, index) in presets" :key="preset.id || 'new-' + index" class="preset-row">
                <div class="preset-grid preset-grid--row1">
                    <div class="preset-field">
                        <label>Produto do Fornecedor</label>
                        <multiselect
                            v-model="preset.provider_product"
                            :options="providerProductOptions"
                            :loading="loadingProviderProducts"
                            :internal-search="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            label="label"
                            track-by="value"
                            placeholder="Busque pelo produto"
                            @search-change="searchProviderProducts"
                            @input="(opt) => onProviderProductChange(index, opt)"
                            select-label=""
                            deselect-label="Remover"
                            selected-label="Selecionado"
                        />
                    </div>
                    <div class="preset-field">
                        <label>Marca</label>
                        <multiselect
                            v-model="preset.brand"
                            :options="brandOptions"
                            :loading="loadingBrands"
                            :internal-search="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            :disabled="!!brand"
                            label="label"
                            track-by="value"
                            placeholder="Busque a marca"
                            @search-change="searchBrands"
                            @input="(opt) => onBrandChange(index, opt)"
                            select-label=""
                            deselect-label="Remover"
                            selected-label="Selecionado"
                        />
                    </div>
                </div>

                <div class="preset-grid preset-grid--row2">
                    <div class="preset-field">
                        <label>Embalagem</label>
                        <multiselect
                            v-model="preset.packing"
                            :options="packingOptions"
                            :loading="loadingPackings"
                            :internal-search="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            :disabled="!!packing"
                            label="label"
                            track-by="value"
                            placeholder="Busque a embalagem"
                            @search-change="searchPackings"
                            @input="(opt) => onPackingChange(index, opt)"
                            select-label=""
                            deselect-label="Remover"
                            selected-label="Selecionado"
                        />
                    </div>
                    <div class="preset-field">
                        <label>Qtd. Embalagem</label>
                        <input
                            type="number"
                            min="0"
                            step="1"
                            :value="preset.packing_quantity"
                            @input="updateField(index, 'packing_quantity', $event.target.value)"
                            placeholder="0"
                        />
                    </div>
                    <div class="preset-field">
                        <label>Fator</label>
                        <input
                            type="number"
                            step="0.01"
                            :value="preset.factor"
                            @input="updateField(index, 'factor', $event.target.value)"
                            placeholder="1"
                        />
                    </div>
                </div>

                <div class="preset-grid preset-row-actions">
                    <div class="preset-field">
                        <textarea
                            rows="2"
                            :value="preset.obs"
                            @input="updateField(index, 'obs', $event.target.value)"
                            placeholder="Observações..."
                        />
                    </div>
                    <div class="preset-action-btns">
                        <cc-button
                            :nolink="true"
                            :classes="'c-btn-save'"
                            :icon="'fa fa-save'"
                            :disabled="savingKey !== null || removingKey !== null"
                            @click="persistPreset(index)"
                        />
                        <cc-button
                            :nolink="true"
                            :classes="'c-btn-remove'"
                            :icon="'fas fa-trash'"
                            :disabled="savingKey !== null || removingKey !== null"
                            @click="removePreset(index)"
                        />
                    </div>
                </div>
            </div>
            <div class="presets-add">
                <cc-button
                    :nolink="true"
                    :classes="'c-btn-neutral'"
                    :icon="'fa fa-plus'"
                    :content="'Adicionar Preset'"
                    :disabled="savingKey !== null || removingKey !== null"
                    @click="addPreset"
                />
            </div>
        </div>
        <div slot="footer">
            <cc-button :nolink="true" :classes="'c-btn-cancel'" :content="'Fechar'" @click="close" />
        </div>
    </cc-modal>
</template>

<script>
import PresetService from "@/services/v3/management/preset.service";
import LoaderV3 from "@/components/ui/loaders/loader-v3.component";

const asNumberOrNull = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
};

// An option's value is only a usable foreign key once it is a real numeric id.
// The winner's brand/packing arrive as free text and stay unresolved whenever the
// lookup finds no match, so anything non-numeric must not reach the API as an id.
const asIdOrNull = (value) => {
    const parsed = asNumberOrNull(value);
    return Number.isInteger(parsed) ? parsed : null;
};

const normalizeList = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.data?.data)) return payload.data.data;
    if (Array.isArray(payload?.items)) return payload.items;
    if (Array.isArray(payload?.results)) return payload.results;
    if (Array.isArray(payload?.content)) return payload.content;
    return [];
};

export default {
    name: "ManagePresetsModal",

    components: { LoaderV3 },

    props: {
        name: { type: String, default: "" },
        product_id: { type: [Number, String], required: true },
        provider_id: { type: [Number, String], required: true },
        brand: { type: String, default: null },
        packing: { type: String, default: null },
        current_winner: { type: Object, default: null },
    },

    data() {
        return {
            service: new PresetService(),
            presets: [],
            loading: false,
            savingKey: null,
            removingKey: null,
            error: null,
            providerProductOptions: [],
            packingOptions: [],
            brandOptions: [],
            loadingProviderProducts: false,
            loadingPackings: false,
            loadingBrands: false,
            searchTimers: {},
            resolvedBrand: null,
            resolvedPacking: null,
        };
    },

    computed: {
        displayLabel() {
            return this.name || `Produto #${this.product_id}`;
        },
        winnerBrand() {
            if (this.resolvedBrand) return this.resolvedBrand;
            if (!this.brand) return null;
            // Unresolved: pro_observacao is free text, so it has no brand id behind
            // it. Show it as a label only — putting the name in `value` made the
            // payload send brand_id: "COSTELATA", which the API rejects with 422.
            return { value: null, label: this.brand };
        },
        winnerPacking() {
            if (this.resolvedPacking) return this.resolvedPacking;
            if (!this.packing) return null;
            return { value: null, label: this.packing };
        },
        modal() {
            return {
                title: "Conciliação de Produto",
                subtitle: "Gerencie os presets de oferta para este produto",
                icon_title: "fas fa-sync-alt",
                nobackbutton: true,
                style: { width: "70%", "max-height": "90vh", "overflow-y": "auto" },
            };
        },
    },

    async mounted() {
        await this.resolveWinnerFields();
        this.loadPresets();
    },

    methods: {
        close() {
            this.$emit("close");
        },

        async resolveWinnerFields() {
            const promises = [];

            if (this.brand) {
                promises.push(
                    this.service
                        .searchBrands(this.brand)
                        .then((response) => {
                            const list = normalizeList(response.data);
                            const match =
                                list.find((item) => {
                                    const label = (item.name || item.mar_nome || "").toLowerCase();
                                    return label === this.brand.toLowerCase();
                                }) || list[0];
                            if (match) {
                                this.resolvedBrand = {
                                    value: match.id || match.mar_id,
                                    label: match.name || match.mar_nome || `#${match.id || match.mar_id}`,
                                };
                                this.brandOptions = [this.resolvedBrand];
                            }
                        })
                        .catch(() => {})
                );
            }

            if (this.packing) {
                const searchTerm = this.packing.split(" ")[0];
                promises.push(
                    this.service
                        .searchPackings(searchTerm)
                        .then((response) => {
                            const list = normalizeList(response.data);
                            const match = list.find((item) => item.abbreviation === searchTerm);
                            if (match) {
                                this.resolvedPacking = {
                                    value: match.id || match.emb_id,
                                    label: match.description || match.emb_sigla || match.name || `#${match.id || match.emb_id}`,
                                };
                                this.packingOptions = [this.resolvedPacking];
                            }
                        })
                        .catch(() => {})
                );
            }

            await Promise.all(promises);
        },
        async loadPresets() {
            if (!this.product_id) return;
            this.loading = true;
            this.error = null;
            try {
                const response = await this.service.list(this.product_id, { provider_id: this.provider_id });
                const list = normalizeList(response.data);
                if (list.length > 0) {
                    this.presets = list.map((item) => ({
                        ...item,
                        provider_product: item.provider_product
                            ? {
                                  value: item.provider_product.id,
                                  label:
                                      (item.provider_product.internal_code ? `[${item.provider_product.internal_code}] ` : "") +
                                      (item.provider_product.name || `#${item.provider_product.id}`),
                              }
                            : null,
                        packing:
                            this.winnerPacking ||
                            (item.packing
                                ? {
                                      value: item.packing.id,
                                      label: item.packing.description || item.packing.emb_sigla || `#${item.packing.id}`,
                                  }
                                : null),
                        brand:
                            this.winnerBrand ||
                            (item.brand ? { value: item.brand.id, label: item.brand.name || `#${item.brand.id}` } : null),
                    }));
                } else {
                    this.presets = [this.buildEmptyPreset()];
                }
            } catch (err) {
                this.error = "Não foi possível carregar os presets.";
                this.presets = [this.buildEmptyPreset()];
            } finally {
                this.loading = false;
            }
        },

        buildEmptyPreset() {
            return {
                id: null,
                provider_product: null,
                provider_product_id: null,
                product_id: this.product_id,
                packing: this.winnerPacking,
                packing_id: null,
                packing_quantity: null,
                brand: this.winnerBrand,
                brand_id: null,
                obs: "",
                factor: 1,
            };
        },

        updateField(index, field, value) {
            const preset = { ...this.presets[index] };
            preset[field] = field === "obs" ? value : asNumberOrNull(value);
            this.$set(this.presets, index, preset);
        },

        onProviderProductChange(index, option) {
            const preset = { ...this.presets[index] };
            preset.provider_product = option || null;
            preset.provider_product_id = option ? option.value : null;
            this.$set(this.presets, index, preset);
        },

        onPackingChange(index, option) {
            const preset = { ...this.presets[index] };
            preset.packing = option || null;
            preset.packing_id = option ? option.value : null;
            this.$set(this.presets, index, preset);
        },

        onBrandChange(index, option) {
            const preset = { ...this.presets[index] };
            preset.brand = option || null;
            preset.brand_id = option ? option.value : null;
            this.$set(this.presets, index, preset);
        },

        async searchProviderProducts(text) {
            if (!text || text.trim().length < 2) return;
            clearTimeout(this.searchTimers.providerProducts);
            this.searchTimers.providerProducts = setTimeout(async () => {
                this.loadingProviderProducts = true;
                try {
                    const response = await this.service.searchProviderProducts(this.provider_id, text);
                    const list = normalizeList(response.data);
                    this.providerProductOptions = list.map((item) => ({
                        value: item.id || item.pro_id,
                        label: (item.internal_code ? `[${item.internal_code}] ` : "") + (item.name || item.pro_descricao || `#${item.id}`),
                    }));
                } catch (err) {
                    this.providerProductOptions = [];
                } finally {
                    this.loadingProviderProducts = false;
                }
            }, 400);
        },

        async searchPackings(text) {
            if (!text || text.trim().length < 2) return;
            clearTimeout(this.searchTimers.packings);
            this.searchTimers.packings = setTimeout(async () => {
                this.loadingPackings = true;
                try {
                    const response = await this.service.searchPackings(text);
                    const list = normalizeList(response.data);
                    this.packingOptions = list.map((item) => ({
                        value: item.id || item.emb_id,
                        label: item.description || item.emb_sigla || item.name || `#${item.id}`,
                    }));
                } catch (err) {
                    this.packingOptions = [];
                } finally {
                    this.loadingPackings = false;
                }
            }, 400);
        },

        async searchBrands(text) {
            if (!text || text.trim().length < 2) return;
            clearTimeout(this.searchTimers.brands);
            this.searchTimers.brands = setTimeout(async () => {
                this.loadingBrands = true;
                try {
                    const response = await this.service.searchBrands(text);
                    const list = normalizeList(response.data);
                    this.brandOptions = list.map((item) => ({
                        value: item.id || item.mar_id,
                        label: item.name || item.mar_nome || `#${item.id}`,
                    }));
                } catch (err) {
                    this.brandOptions = [];
                } finally {
                    this.loadingBrands = false;
                }
            }, 400);
        },

        async persistPreset(index) {
            this.savingKey = index;
            this.error = null;
            const preset = this.presets[index];
            const providerProductId = preset.provider_product?.value ?? preset.provider_product_id;

            if (!providerProductId) {
                this.error = "Selecione um produto do fornecedor antes de salvar.";
                this.savingKey = null;
                return;
            }

            const payload = {
                provider_product_id: providerProductId,
                product_id: this.product_id,
                packing_quantity: preset.packing_quantity ?? null,
                packing_id: asIdOrNull(preset.packing?.value ?? preset.packing_id),
                brand_id: asIdOrNull(preset.brand?.value ?? preset.brand_id),
                obs: preset.obs || "",
                factor: preset.factor ?? null,
                id: preset.id ?? undefined,
            };

            try {
                if (payload.id) {
                    await this.service.update(this.product_id, payload.id, payload);
                } else {
                    await this.service.create(this.product_id, payload);
                }
                this.$emit("preset_created");
                await this.loadPresets();
            } catch (err) {
                // The API answers 422 with the field-level reason (e.g. "A marca
                // informada não existe"); a blanket message hides exactly what the
                // admin needs to fix.
                const data = err.response?.data;
                this.error =
                    data?.errors?.[0] ||
                    data?.message ||
                    "Não foi possível salvar o preset.";
            } finally {
                this.savingKey = null;
            }
        },

        async removePreset(index) {
            const preset = this.presets[index];
            if (!preset?.id) {
                this.presets.splice(index, 1);
                return;
            }

            this.removingKey = index;
            this.error = null;
            try {
                await this.service.remove(this.product_id, preset.id);
                this.$emit("preset_created");
                await this.loadPresets();
            } catch (err) {
                this.error = "Não foi possível remover o preset.";
            } finally {
                this.removingKey = null;
            }
        },

        addPreset() {
            this.presets.push(this.buildEmptyPreset());
        },
    },
};
</script>
